// extracted by mini-css-extract-plugin
export var activityContainer = "_m3-0";
export var typingIndicatorContainer = "_m3-1";
export var typingIndicatorDot = "_m3-2";
export var wave = "_m3-3";